import React from 'react';
import { Chessboard } from "react-chessboard";
import { useTheme, ThemedCard } from './ThemeContext';

const ChessGameLayout = ({
  position,
  boardOrientation,
  onSquareClick,
  onSquareRightClick,
  onPieceDrop,
  customSquareStyles,
  customArrows,
  customPieces,
  isDraggablePiece,
  renderPlayerInfo,
  renderGameStatus,
  renderControls,
  onPromotionPieceSelect,
  promotionToSquare,
  showPromotionDialog,
  animationDuration = 200,
  countdownTimer,
  isRegularGame = false
}) => {
  const { woodStyles } = useTheme();

  return (
    <div className="flex-1 flex flex-col lg:flex-row gap-4 ">
      {/* Main game section */}
      <div className="flex w-full lg:w-[60%]">
        <ThemedCard className="w-full flex flex-col min-h-0">
          {/* Game container that will scale as a unit */}
          <div className="flex flex-col flex-1">
            {/* Top player info */}
            <div className="flex-none border-b border-opacity-20"
              style={{ borderColor: woodStyles.borderColor }}>
              {renderPlayerInfo(boardOrientation === "white" ? "black" : "white")}
            </div>

            {/* Chessboard container */}
            <div className="flex-1 flex items-center justify-center p-2 min-h-0">
              {countdownTimer !== null && (
                <div className="absolute inset-0 z-10 bg-black bg-opacity-50 flex items-center justify-center">
                  <div className="text-6xl font-bold text-white animate-pulse">
                    {countdownTimer}
                  </div>
                </div>
              )}
              <div className="max-w-full" style={{
                width: 'min(60vh, 100%)',
                aspectRatio: '1',
                opacity: countdownTimer !== null ? 0.5 : 1,
                pointerEvents: countdownTimer !== null ? 'none' : 'auto'
              }}>
                <Chessboard
                  position={position}
                  boardOrientation={boardOrientation}
                  onSquareClick={onSquareClick}
                  onSquareRightClick={onSquareRightClick}
                  promotionToSquare={promotionToSquare}
                  onPromotionPieceSelect={onPromotionPieceSelect}
                  showPromotionDialog={showPromotionDialog}
                  onPieceDrop={onPieceDrop}
                  customSquareStyles={customSquareStyles}
                  customArrows={customArrows}
                  customPieces={customPieces}
                  customDarkSquareStyle={{ backgroundColor: "#779952" }}
                  customLightSquareStyle={{ backgroundColor: "#edeed1" }}
                  isDraggablePiece={isDraggablePiece}
                  areArrowsAllowed={true}
                  animationDuration={isRegularGame ? 0 : animationDuration}
                  snapToCursor={false}
                  arePremovesAllowed={isRegularGame}
                />
              </div>
            </div>

            {/* Bottom player info */}
            <div className="flex-none border-t border-opacity-20"
              style={{ borderColor: woodStyles.borderColor }}>
              {renderPlayerInfo(boardOrientation === "white" ? "white" : "black")}
            </div>
          </div>
        </ThemedCard>
      </div>

      {/* Side panel */}
      <div className="w-full lg:w-[30%] flex flex-col gap-4">
        {/* Game status window */}
        <ThemedCard>
          <div className="px-3 py-2 border-b border-opacity-20"
            style={{ borderColor: woodStyles.borderColor }}>
            <span className={`text-sm font-semibold ${woodStyles.text.primary}`}>
              Game Status
            </span>
          </div>
          <div className="p-4">
            {renderGameStatus()}
          </div>
        </ThemedCard>

        {/* Controls window */}
        <ThemedCard>
          <div className="px-3 py-2 border-b border-opacity-20"
            style={{ borderColor: woodStyles.borderColor }}>
            <span className={`text-sm font-semibold ${woodStyles.text.primary}`}>
              Game Controls
            </span>
          </div>
          <div className="p-4">
            <div className="flex flex-wrap gap-2 justify-center">
              {renderControls()}
            </div>
          </div>
        </ThemedCard>
      </div>
    </div>
  );
};

export default ChessGameLayout;